<template>
    <div class="content-page">
        <div class="content-nav">
            <el-breadcrumb class="breadcrumb" separator="/">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="operation-nav">
                <router-link to="/dashboard/add_home_ads">
                    <el-button type="primary" icon="plus" size="small">添加广告</el-button>
                </router-link>
            </div>
        </div>
        <div class="content-main">
            
            <div class="form-table-box">

                <el-table :data="tableData" style="width: 100%" stripe>
                    <el-table-column prop="ads_name" label="广告名" width="120"></el-table-column>

                    <el-table-column prop="ads_pic_url" label="广告封面" width="180">
                        <template scope="scope">
                            <img :src="scope.row.ads_pic_url" alt="" style="width: 60px;height: 60px">
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="link_name" label="关联内容"></el-table-column>

                    <el-table-column prop="ads_type" label="类型" :formatter="analysisAdsType"></el-table-column>

                    <el-table-column label="操作">
                        <template scope="scope">
                            <el-button size="small" @click="handleRowEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="small" plain type="danger" @click="handleRowDelete(scope.$index, scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="size"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                page: 0,
				size:10,
                total: 0,
                tableData: [],
                pIndex: 0,
                num: 0,
            }
        },
        methods: {

            analysisAdsType(row, column) {
                if (row.ads_type === 3) {
                    return '商品'
                } else if (row.ads_type === 6)  {
                    return '文章'
                } else if (row.ads_type === 9)  {
                    return '视频'
                } else if (row.ads_type === 12)  {
                    return '网页跳转'
                } else if (row.ads_type === 15)  {
                    return '小程序跳转'
                } 
                else
                {
                    return "其他"
                }
            },
    
            handlePageChange(val) {
                this.page = val;
                let nIndex = this.pIndex;
                if (nIndex == 0) {
                    this.getList();
                }
            },
            handleRowEdit(index, row) {
                this.$router.push({name: 'add_home_ads', query: {id: row._id,adsinfo:this.tableData[index]}});
            },
            handleRowDelete(index, row) {

                this.$confirm('确定要删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let that = this;
                    that.axios.post('home/deleteAds', {id: row._id}).then((response) => {
                        if (response.data.code > 0) {
                            that.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            that.getadsList();
                        }
                    })
                }).catch(() => {

                });
            },
            onSubmitFilter() {
                this.page = 1;
                this.getList();
            },
            getadsList() {
                this.axios.get('home/getAdsList', {
                    params: {
                        page: this.page,
						size: this.size
                    }
                }).then((response) => {
                    this.tableData = response.data.data
                })
            }
        },
        components: {},
        mounted() {
            this.getadsList();
        }
    }

</script>

<style scoped>
    .sort-width{
        width: 90px;
    }
    .right{
        float: right;
    }
    .form-inline {
        margin-top: 2px;
        height: 40px;
        margin-right: 20px;
    }

    .block {
        margin-bottom: 10px;
        height:42px;
        display: flex;
        align-items: center;
        justify-content:space-between;
    }

    .active {
        border-color: #ff4949;
        color: #ff4949;
    }

    .marginRight{
        margin-right: 20px;
    }
</style>
